export const sidenav = {
  remote: 'simplify_hub_navbar_mfe',
  name: 'sidenav',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4323/mf-manifest.json',
    'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-navbar/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-navbar/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-navbar/v1/mf2/mf-manifest.json',
  },
};

export default sidenav;
